import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/excelInformeSeguimientoExtraccionesPool`, method: 'POST', body: list, token: token})
}